class QhPlanoResumo {
  constructor(dados) {
    this.id = dados ? dados.id : null;
    this.ano = dados ? dados.ano : null;
    this.numero = dados ? dados.numero : null;
    this.descricao = dados ? dados.descricao : null;
    this.dataInicio = dados ? dados.dataInicio : null;
    this.dataFim = dados ? dados.dataFim : null;
    this.ativo = dados ? dados.ativo : null;
  }
}
export default QhPlanoResumo;
